import getAWSCredentials from '../getAWSIoTCreds'

async function getIoTCreds () {
  const response = await getAWSCredentials()
  return response.data.credentials
}

export {
  getIoTCreds
}
